import React from 'react'
import {Typography, Box} from '@material-ui/core'

const Page404 = () => (
  <Box mt={4}>
    <Typography variant="subtitle1" gutterBottom>
      Page not found 404
    </Typography>
  </Box>
)
export default Page404
